// ExpandingCircleMenu.js
import React, { useState } from "react";
import "./ExpandingCircleMenu.css";

import { SquarePen, LibraryBig, BookImage, Plus } from "lucide-react";

import { useNavigate } from "react-router-dom";

const SvgArcCircle = ({ size = 80, stroke = 4, color = "#3498db", rotation = 0, style = {} }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const arcLength = circumference / 4;

  return (
    <svg
      width={size}
      height={size}
      style={{ transform: `rotate(${rotation}deg)`, ...style }}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeDasharray={`${arcLength} ${circumference}`}
        strokeDashoffset={0}
        strokeLinecap="round"
      />
    </svg>
  );
};


const CircleAnimation = () => {

  const navigate = useNavigate();
  const [startAnimation, setStartAnimation] = useState(false);
  const [isFirstTimeExpanded, setIsFirstTimeExpanded] = useState(false);

  const handleClick = () => {
    setIsFirstTimeExpanded(true);
    setStartAnimation(prev=>!startAnimation);
  };

  return (
    <>
      <div className="circle-outer-container"
        /*onClick={() => setStartAnimation(false)}*/
      ></div>
      <div className="circle-container"
        /*onClick={() => setStartAnimation(false)}*/
      >
        <div className={`circle-icon rotate-plus-div ${startAnimation ? "rotate-plus" : (isFirstTimeExpanded ? "reverse-plus" : "")}`}
          style={{ 
            color: "#3498db", 
            transition: "transform 0.7s ease-in-out",
          }}
        >
          <Plus size={30} />
        </div>

        <div className={`circle-wrapper circle-a-wrapper ${startAnimation ? "animate-a" : (isFirstTimeExpanded ? "reverse-a" : "")}`} 
          onClick={(e) => { e.stopPropagation(); handleClick(); }}
        >
          <div className={`${startAnimation ? "rotate-a" : (isFirstTimeExpanded ? "reverse-rotate-a" : "")}`}>
            <SvgArcCircle color="#3498db" rotation={180} />
          </div>
        </div>

        <div className={`circle-wrapper circle-b-wrapper ${startAnimation ? "animate-b" : (isFirstTimeExpanded ? "reverse-b" : "")}`}
          onClick={(e) => { e.stopPropagation(); navigate("/myInfo/createQuestionSets"); }}
        >
          <div className={`${startAnimation ? "rotate-b" : (isFirstTimeExpanded ? "reverse-rotate-b" : "")}`}>
            <SvgArcCircle color="#2ecc71" />
          </div>
          <div className="circle-icon" style={{ color: "#2ecc71", bottom: "25px", left: "26.5px" }}>
            <SquarePen size={28} />
          </div>
          <div className="circle-label">新增題組</div>
        </div>

        <div className={`circle-wrapper circle-c-wrapper ${startAnimation ? "animate-c" : (isFirstTimeExpanded ? "reverse-c" : "")}`}
          onClick={(e) => { e.stopPropagation(); navigate("/page-c"); }}
        >
          <div className={`${startAnimation ? "rotate-c" : (isFirstTimeExpanded ? "reverse-rotate-c" : "")}`}>
            <SvgArcCircle color="#f1c40f" />
          </div>
          <div className="circle-icon" style={{ color: "#f1c40f", bottom: "25.5px", left: "28px" }}>
            <LibraryBig size={28} />
          </div>
          <div className="circle-label">我的書架</div>
        </div>

        <div className={`circle-wrapper circle-d-wrapper ${startAnimation ? "animate-d" : (isFirstTimeExpanded ? "reverse-d" : "")}`}
          onClick={(e) => { e.stopPropagation(); navigate("/page-d"); }}
        >
          <div className={`${startAnimation ? "rotate-d" : (isFirstTimeExpanded ? "reverse-rotate-d" : "")}`}>
            <SvgArcCircle color="#e74c3c" rotation={90}/>
          </div>
          <div className="circle-icon" style={{ color: "#e74c3c", bottom: "25.5px", left: "26.5px" }}>
            <BookImage size={28} />
          </div>
          <div className="circle-label">探索主題</div>
        </div>

      </div>
    </>
  );
};

export default CircleAnimation;






